import styled from "styled-components";
///@ts-ignore
import avatar1 from "../imgs/avatar/1.png";
///@ts-ignore
import avatar2 from "../imgs/avatar/2.png";
///@ts-ignore
import avatar3 from "../imgs/avatar/3.png";
///@ts-ignore
import avatar4 from "../imgs/avatar/4.png";
///@ts-ignore
import avatar5 from "../imgs/avatar/5.png";
///@ts-ignore
import avatar6 from "../imgs/avatar/6.png";
///@ts-ignore
import avatar7 from "../imgs/avatar/7.png";
///@ts-ignore
import avatar8 from "../imgs/avatar/8.png";
///@ts-ignore
import avatar9 from "../imgs/avatar/9.png";
///@ts-ignore
import avatar10 from "../imgs/avatar/10.png";
///@ts-ignore
import arrow from "../imgs/right-arrow.png";
///@ts-ignore
import down from "../imgs/down-arrow.png";
//@ts-ignore
import ReactMarkdown from "react-markdown";
//@ts-ignore
import google from "../imgs/google.png";
//@ts-ignore
import trip from "../imgs/trip.png";
//@ts-ignore
import plus from "../imgs/plus.png";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getChatTripInfo,
  postChatGoogleList,
  postChatList,
  postChatTripList,
} from "../../api/event";
import { useSearchParams } from "react-router-dom";
import CLOVASpeech from "../chat/CLOVASpeech";
import { Box, Button, Modal } from "@mui/material";

const ChatBubble = ({
  record,
  isAvatar,
  selectEvent,
  setSelectEvert,
  setIsGoogle,
  isGoogle,
  setIsTrip,
  isTrip,
  setRecordMsg,
  isResetList,
  setIsResetList,
  isDisabledBtn,
  mode,
  stop,
}: {
  record: string;
  isAvatar: boolean;
  selectEvent: string;
  setSelectEvert: any;
  step: number;
  setIsGoogle: any;
  isGoogle: boolean;
  setIsTrip: any;
  isTrip: boolean;
  setRecordMsg: any;
  isResetList: boolean;
  setIsResetList: any;
  isDisabledBtn: boolean;
  mode: string;
  stop: boolean;
}) => {
  const [infoData, setInfoData] = useState({});
  const [searchParams] = useSearchParams();
  const queryValue = searchParams.get("typeName");
  const [googleKeyword, setGoogleKeyword] = useState("");
  const [tripKeyword, setTripKeyword] = useState("");
  const [tripID, setTripID] = useState("");
  const [tripDetailLink, setTripDetailLink] = useState("");

  const onClickInfo = (item: any) => {
    setSelectEvert(item.title);
    setInfoData(item);
  };

  const { data: getChatTripDetail, refetch: refetchTrip } = useQuery({
    queryKey: ["getChatTripDetail"],
    //@ts-ignore
    queryFn: () => getChatTripInfo(tripID),
    enabled: tripID !== undefined,
  });

  useEffect(() => {
    if (
      tripDetailLink !== undefined &&
      tripDetailLink !== "" &&
      tripDetailLink !== "No link"
    ) {
      window.open(tripDetailLink, "_blank");
    } else {
      return;
    }
  }, [tripDetailLink]);

  useEffect(() => {
    if (tripID) {
      refetchTrip();
    }
  }, [tripID]);

  const { data: getChatGoogleList } = useQuery({
    queryKey: ["getChatGoogleLists"],
    queryFn: () => postChatGoogleList(googleKeyword),
    enabled: !!googleKeyword,
  });

  useEffect(() => {
    setTripDetailLink(getChatTripDetail?.data.link);
  }, [getChatTripDetail, tripID]);

  const { data: getChatTripList } = useQuery({
    queryKey: ["getChatTripList"],
    queryFn: () => postChatTripList(tripKeyword),
    enabled: !!tripKeyword && isTrip,
  });

  const googleList = getChatGoogleList?.data[0]?.content
    .map((el: any) => el.title)
    .join(". ");

  const tripList = getChatTripList?.data[0]?.content
    .map((el: any) => el.title)
    .join(". ");

  const { data: getChatLists, isSuccess: chatSuccess } = useQuery({
    queryKey: ["getChatList"],
    queryFn: () =>
      postChatList(queryValue as string, {
        msg: record,
      }),
    enabled: !!record,
  });

  useEffect(() => {
    setGoogleKeyword(getChatLists?.data[0].keyword || "");
    setTripKeyword(getChatLists?.data[0].keyword || "");
  }, [chatSuccess, getChatLists?.data]);

  const [defaultMsg, setDefaultMsg] = useState([
    "안녕하세요, 좋은 하루 보내시고 계시나요?",
  ]);

  useEffect(() => {
    if (queryValue === "event") {
      setDefaultMsg([
        ...defaultMsg,
        "어떤 행사를 추천해 드릴까요? 장소, 날짜, 원하시는 활동을 말씀해 주시면 더 맞는 추천을 해드려요!",
      ]);
    }
    if (queryValue === "company") {
      setDefaultMsg([
        ...defaultMsg,
        "어떤 기업을 추천해 드릴까요? 기업의 산업군 또는 참여 행사를 알려주시면 더 맞는 추천을 해드려요!",
      ]);
    }
    if (queryValue === "tour") {
      setDefaultMsg([
        ...defaultMsg,
        "어떤 여행을 추천해 드릴까요? 지역, 날짜, 여행 키워드를 말씀해 주시면 더 맞는 추천을 해드려요!",
      ]);
    }
    if (queryValue === "mall") {
      setDefaultMsg([
        ...defaultMsg,
        "어떤 상품을 추천해 드릴까요? 상품의 용도나 생산 기업을 알려주시면 더 맞는 추천을 해드려요!",
      ]);
    }
  }, [queryValue]);

  const onChangeGoogle = () => {
    setIsGoogle(true);
    setIsTrip(false);
  };

  const onChangeTrip = () => {
    setIsTrip(true);
    setIsGoogle(false);
  };

  const onClickTripID = (id: string) => {
    setTripID(id);
  };

  function extractTitles(data: any[]) {
    //@ts-ignore
    const titleArr = [];

    data?.forEach((item: any) => {
      if (Array.isArray(item.content)) {
        item.content?.forEach((contentItem: any) => {
          if (contentItem.title) {
            titleArr.push(contentItem.title);
          }
        });
      }
    });

    //@ts-ignore
    return titleArr.join(", ");
  }

  const titls = extractTitles(getChatLists?.data);

  const avatarImg = () => {
    if (localStorage.getItem("profile") === "nsinu") {
      return avatar1;
    }

    if (localStorage.getItem("profile") === "nes_c_mikyung") {
      return avatar2;
    }

    if (localStorage.getItem("profile") === "njonghyun") {
      return avatar3;
    }

    if (localStorage.getItem("profile") === "njiyun") {
      return avatar4;
    }

    if (localStorage.getItem("profile") === "nes_c_sohyun") {
      return avatar5;
    }

    if (localStorage.getItem("profile") === "nwoof") {
      return avatar6;
    }

    if (localStorage.getItem("profile") === "nyoungil") {
      return avatar7;
    }

    if (localStorage.getItem("profile") === "nyuna") {
      return avatar8;
    }

    if (localStorage.getItem("profile") === "njiwon") {
      return avatar9;
    }

    if (localStorage.getItem("profile") === "nara_call") {
      return avatar10;
    } else {
      return avatar1;
    }
  };

  useEffect(() => {
    const detailRef = document.getElementById("detailRef");
    //@ts-ignore
    detailRef?.current.scrollIntoView({ behavior: "smooth" });
  }, [isTrip, tripList, googleList, isAvatar]);

  return (
    <>
      {isAvatar ? (
        <AvatarWrapper>
          <img src={avatarImg()} alt="" height={500} />
          <Wrapper>
            {record && (
              <div className="chat-bubble-record">
                <div>{record}</div>
              </div>
            )}

            {record ? (
              <div className="chat-bubble-record-empty-hide">
                <CLOVASpeech
                  mode={mode}
                  stop={stop}
                  isDisabledBtn={isDisabledBtn}
                  recordMsg={record}
                  setRecordMsg={setRecordMsg}
                  isAvatar={isAvatar}
                  ttsData={defaultMsg}
                  setIsResetList={setIsResetList}
                  titls={titls}
                  //@ts-ignore
                  trip={
                    isTrip &&
                    `트립어드바이저를 클릭하셨습니다! 관련정보를 알려드릴게요 ${tripList}`
                  }
                  //@ts-ignore
                  google={
                    isGoogle &&
                    `다른플랫폼 검색하기를 클릭하셨습니다! 관련정보를 알려드릴게요 ${googleList}`
                  }
                  //@ts-ignore
                  detail={
                    selectEvent &&
                    `${selectEvent}를 클릭하셨습니다! 관련정보를 알려드릴게요. ${
                      //@ts-ignore
                      infoData.title
                      //@ts-ignore
                    } ${infoData.summary || ""}`
                  }
                />
              </div>
            ) : (
              <div className="chat-bubble-record-empty">
                <CLOVASpeech
                  stop={stop}
                  mode={mode}
                  isDisabledBtn={isDisabledBtn}
                  recordMsg={record}
                  setRecordMsg={setRecordMsg}
                  ttsData={defaultMsg}
                  setIsResetList={setIsResetList}
                  titls={titls}
                  isAvatar={isAvatar}
                  //@ts-ignore
                  detail={
                    selectEvent &&
                    `${selectEvent}를 클릭하셨습니다! 관련정보를 알려드릴게요. ${
                      //@ts-ignore
                      infoData.title
                      //@ts-ignore
                    } ${infoData.summary || ""}`
                  }
                />
              </div>
            )}

            {!isResetList && (
              <>
                {getChatLists?.data?.map((el: any, idx: number) => (
                  <div className="chat-info" key={idx}>
                    <h2>{el.type}</h2>
                    <div>
                      {el.content.length !== 0 ? (
                        el.content.map((item: any, idx: number) => (
                          <div key={idx}>
                            <button
                              onClick={() => onClickInfo(item)}
                              // disabled={!!selectEvent}
                            >
                              <img src={arrow} alt="" height={24} />
                              {item.title}
                            </button>
                            <p>{(item.e_date && `~${item.e_date}`) || ""}</p>
                          </div>
                        ))
                      ) : (
                        <p className="empty">검색결과가 존재하지 않습니다.</p>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}

            {record && getChatLists && (
              <GoogleButton onClick={onChangeGoogle}>
                <img src={google} width={10} alt="" />
                <p>다른 플랫폼 검색하기</p>
                <img src={plus} width={16} alt="" />
              </GoogleButton>
            )}
            {/** 여행일때만 트립어드바이저 노출 */}
            {record && getChatLists && queryValue === "tour" && (
              <TripButton onClick={onChangeTrip}>
                <img src={trip} width={16} alt="" />
                <p>트립어드바이저</p>
                <img src={plus} width={16} alt="" />
              </TripButton>
            )}

            <br />
            {selectEvent && (
              <>
                <div className="chat-bubble">
                  <p>
                    "{selectEvent}"를 클릭하셨습니다! 관련정보를 알려드릴게요.
                  </p>
                </div>

                <button className="label">
                  <img src={down} alt="" height={24} />
                  {selectEvent}
                </button>

                <InfoWrapper>
                  {/** @ts-ignore */}
                  <img src={infoData.image} alt="" />
                  {/** @ts-ignore */}
                  <a href={infoData.url} target="_black">
                    {/** @ts-ignore */}
                    {infoData.title}
                  </a>
                  <div>
                    {/** @ts-ignore */}
                    <ReactMarkdown>{infoData.summary}</ReactMarkdown>
                    <p>
                      {/** @ts-ignore */}
                      {infoData.s_date && infoData.e_date && (
                        <>
                          {/** @ts-ignore */}
                          행사기간 : {infoData.s_date} - {infoData.e_date}
                        </>
                      )}
                    </p>
                  </div>
                </InfoWrapper>
              </>
            )}

            {isGoogle && (
              <Google>
                <div className="chat-bubble">
                  `다른 플랫폼 검색하기`를 클릭하셨습니다! 관련정보를
                  알려드릴게요.
                </div>

                <div className="chat-info">
                  <div>
                    {/** @ts-ignore */}
                    {getChatGoogleList?.data[0]?.content?.map((item, idx) => (
                      <div key={idx}>
                        <a href={item.link}>
                          <img src={arrow} alt="" height={24} />
                          {item.title}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </Google>
            )}

            {isTrip && (
              <Google>
                <div className="chat-bubble">
                  `트립어드바이저`를 클릭하셨습니다! 관련정보를 알려드릴게요.
                </div>

                <div className="chat-info">
                  <div>
                    {/** trip에 맞게 변경해야함 */}
                    {/** @ts-ignore */}
                    {getChatTripList?.data[0]?.content?.map((item, idx) => (
                      <Button onClick={() => onClickTripID(item.id)}>
                        <div>
                          <a href={item.link}>
                            <img src={arrow} alt="" height={24} />
                            {item.title}
                          </a>
                        </div>
                      </Button>
                    ))}
                  </div>
                </div>
              </Google>
            )}
          </Wrapper>
          <section className="detailRef"></section>
        </AvatarWrapper>
      ) : (
        <Wrapper>
          {defaultMsg?.map((el, idx) => (
            <div className="chat-bubble" key={idx}>
              {el}
            </div>
          ))}

          {record && (
            <div className="chat-bubble-record">
              <div>{record}</div>
            </div>
          )}

          {record ? (
            <div className="chat-bubble-record-empty-hide">
              <CLOVASpeech
                mode={mode}
                stop={stop}
                isDisabledBtn={isDisabledBtn}
                recordMsg={record}
                setRecordMsg={setRecordMsg}
                isAvatar={isAvatar}
                ttsData={defaultMsg}
                setIsResetList={setIsResetList}
                titls={titls}
                //@ts-ignore
                trip={
                  isTrip &&
                  `트립어드바이저를 클릭하셨습니다! 관련정보를 알려드릴게요 ${tripList}`
                }
                //@ts-ignore
                google={
                  isGoogle &&
                  `다른플랫폼 검색하기를 클릭하셨습니다! 관련정보를 알려드릴게요 ${googleList}`
                }
                //@ts-ignore
                detail={
                  selectEvent &&
                  `${selectEvent}를 클릭하셨습니다! 관련정보를 알려드릴게요. ${
                    //@ts-ignore
                    infoData.title
                    //@ts-ignore
                  } ${infoData.summary || ""}`
                }
              />
            </div>
          ) : (
            <div className="chat-bubble-record-empty">
              <CLOVASpeech
                stop={stop}
                mode={mode}
                isDisabledBtn={isDisabledBtn}
                recordMsg={record}
                setRecordMsg={setRecordMsg}
                ttsData={defaultMsg}
                setIsResetList={setIsResetList}
                titls={titls}
                isAvatar={isAvatar}
                //@ts-ignore
                detail={
                  selectEvent &&
                  `${selectEvent}를 클릭하셨습니다! 관련정보를 알려드릴게요. ${
                    //@ts-ignore
                    infoData.title
                    //@ts-ignore
                  } ${infoData.summary || ""}`
                }
              />
            </div>
          )}

          {!isResetList && (
            <>
              {getChatLists?.data?.map((el: any, idx: number) => (
                <div className="chat-info" key={idx}>
                  <h2>{el.type}</h2>
                  <div>
                    {el.content.length !== 0 ? (
                      el.content.map((item: any, idx: number) => (
                        <div key={idx}>
                          <button
                            onClick={() => onClickInfo(item)}
                            // disabled={!!selectEvent}
                          >
                            <img src={arrow} alt="" height={24} />
                            {item.title}
                          </button>
                          <p>{(item.e_date && `~${item.e_date}`) || ""}</p>
                        </div>
                      ))
                    ) : (
                      <p className="empty">검색결과가 존재하지 않습니다.</p>
                    )}
                  </div>
                </div>
              ))}
            </>
          )}

          {record && getChatLists && (
            <GoogleButton onClick={onChangeGoogle}>
              <img src={google} width={10} alt="" />
              <p>다른 플랫폼 검색하기</p>
              <img src={plus} width={16} alt="" />
            </GoogleButton>
          )}
          {/** 여행일때만 트립어드바이저 노출 */}
          {record && getChatLists && queryValue === "tour" && (
            <TripButton onClick={onChangeTrip}>
              <img src={trip} width={16} alt="" />
              <p>트립어드바이저</p>
              <img src={plus} width={16} alt="" />
            </TripButton>
          )}

          <br />

          {selectEvent && (
            <>
              <div className="chat-bubble">
                <p>
                  "{selectEvent}"를 클릭하셨습니다! 관련정보를 알려드릴게요.
                </p>
              </div>

              <button className="label">
                <img src={down} alt="" height={24} />
                {selectEvent}
              </button>

              <InfoWrapper>
                {/** @ts-ignore */}
                <img src={infoData.image} alt="" />
                {/** @ts-ignore */}
                <a href={infoData.url} target="_black">
                  {/** @ts-ignore */}
                  {infoData.title}
                </a>
                <div>
                  {/** @ts-ignore */}
                  <ReactMarkdown>{infoData.summary}</ReactMarkdown>
                  <p>
                    {/** @ts-ignore */}

                    {infoData.s_date && infoData.e_date && (
                      <>
                        {/** @ts-ignore */}
                        행사기간 : {infoData.s_date} - {infoData.e_date}
                      </>
                    )}
                  </p>
                </div>
              </InfoWrapper>
              <section className="detailRef"></section>
            </>
          )}

          {isGoogle && (
            <Google>
              <div className="chat-bubble">
                `다른 플랫폼 검색하기`를 클릭하셨습니다! 관련정보를
                알려드릴게요.
              </div>

              <div className="chat-info">
                <div>
                  {/** @ts-ignore */}
                  {getChatGoogleList?.data[0]?.content?.map((item, idx) => (
                    <div key={idx}>
                      <a href={item.link}>
                        <img src={arrow} alt="" height={24} />
                        {item.title}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </Google>
          )}

          {isTrip && (
            <Google>
              <div className="chat-bubble">
                `트립어드바이저`를 클릭하셨습니다! 관련정보를 알려드릴게요.
              </div>

              <div className="chat-info">
                <div>
                  {/** trip에 맞게 변경해야함 */}
                  {/** @ts-ignore */}
                  {getChatTripList?.data[0]?.content?.map((item, idx) => (
                    <Button onClick={() => onClickTripID(item.id)}>
                      <div>
                        <a href={item.link}>
                          <img src={arrow} alt="" height={24} />
                          {item.title}
                        </a>
                      </div>
                    </Button>
                  ))}
                </div>
              </div>
            </Google>
          )}
        </Wrapper>
      )}
    </>
  );
};

export default ChatBubble;

const Google = styled.div`
  /* height: 100vh; */
`;

const TripButton = styled.button`
  border: 0;
  margin-left: 10px;
  width: fit-content;
  background-color: rgba(76, 80, 84, 1);
  padding: 10px;
  color: white;
  font-size: 12px;
  border-radius: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  > img:first-child {
    margin-right: 5px;
  }

  > img:last-child {
    margin-left: 10px;
  }
`;

const GoogleButton = styled.button`
  border: 0;
  margin-left: 10px;
  width: fit-content;
  background-color: rgba(37, 124, 255, 1);
  padding: 10px;
  color: white;
  font-size: 12px;
  border-radius: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  > img:first-child {
    margin-right: 5px;
  }

  > img:last-child {
    margin-left: 10px;
  }
`;

const InfoWrapper = styled.div`
  margin: 10px;
  padding: 10px;
  max-width: 500px;
  background-color: white;

  > img {
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
  }

  > a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: rgba(249, 154, 45, 1);
    border: 0;
    padding: 10px;
    color: white;
    border-radius: 8px;
    font-size: 14px;
    margin-top: 20px;
  }

  > div {
    color: rgba(76, 80, 84, 1);
    font-size: 12px;
    margin-top: 10px;
    line-height: 19.2px;
    font-family: Pretendard;
  }
`;

const AvatarWrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100vh;

  > img {
    position: relative;
    margin: 0 auto;
    width: 100%;
    object-fit: contain;
  }

  > div {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    overflow: scroll;
  }
`;

const Wrapper = styled.div`
  .empty {
    color: #898989;
    padding: 10px;
  }

  .chat-bubble {
    width: 270px;
    line-height: 21px;
    display: flex;
    margin-left: 10px;
    margin-top: 10px;
    background-color: #ffffff;
    padding: 10px 15px;
    font-size: 14px;
    color: rgba(76, 80, 84, 1);
    font-size: 14px;
    overflow: auto;
  }

  .label {
    width: fit-content;
    background-color: rgba(255, 255, 255, 0.8);
    color: rgba(249, 154, 45, 1);
    font-size: 14px;
    font-weight: 700;
    padding: 10px;
    border-radius: 35px;
    display: flex;
    align-items: center;
    border: 0;
    margin-top: 10px;
    margin-left: 10px;

    > img {
      margin-right: 5px;
    }
  }

  .chat-info {
    padding: 10px;

    > h2 {
      color: rgba(105, 130, 169, 1);
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 5px;
      margin-top: 10px;
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      > div {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        > button {
          width: fit-content;
          background-color: rgba(255, 255, 255, 0.8);
          color: rgba(37, 124, 255, 1);
          font-size: 14px;
          font-weight: 700;
          padding: 10px;
          border-radius: 35px;
          display: flex;
          align-items: center;
          border: 0;

          > img {
            margin-right: 5px;
          }
        }

        > a {
          width: fit-content;
          background-color: rgba(255, 255, 255, 0.8);
          color: rgba(37, 124, 255, 1);
          font-size: 14px;
          font-weight: 700;
          padding: 10px;
          border-radius: 35px;
          display: flex;
          align-items: center;
          border: 0;

          > img {
            margin-right: 5px;
          }
        }

        > p {
          margin-left: 5px;
          color: rgba(114, 114, 114, 1);
          font-weight: 600;
          font-size: 12px;
        }
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      > button {
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          > button {
            width: fit-content;
            background-color: rgba(255, 255, 255, 0.8);
            color: rgba(37, 124, 255, 1);
            font-size: 14px;
            font-weight: 700;
            padding: 10px;
            border-radius: 35px;
            display: flex;
            align-items: center;
            border: 0;

            > img {
              margin-right: 5px;
            }
          }

          > a {
            width: fit-content;
            background-color: rgba(255, 255, 255, 0.8);
            color: rgba(37, 124, 255, 1);
            font-size: 14px;
            font-weight: 700;
            padding: 10px;
            border-radius: 35px;
            display: flex;
            align-items: center;
            border: 0;

            > img {
              margin-right: 5px;
            }
          }

          > p {
            margin-left: 5px;
            color: rgba(114, 114, 114, 1);
            font-weight: 600;
            font-size: 12px;
          }
        }
      }
    }
  }

  .chat-bubble-record-empty-hide {
    display: none;
  }
  .chat-bubble-record-empty {
    display: flex;
    margin-right: 10px;
    margin-top: 20px;
    justify-content: flex-end;
    align-items: flex-end;

    > div {
      /* width: 250px; */
      width: auto;
      padding: 10px 15px;
      font-size: 14px;
      line-height: 21px;
      color: rgba(76, 80, 84, 1);

      > button {
        border: 0;
        margin-right: 5px;
      }
    }
  }

  .chat-bubble-record {
    display: flex;
    margin-right: 10px;
    margin-top: 20px;
    justify-content: flex-end;
    align-items: flex-end;

    > div {
      width: 250px;
      background-color: #ffffff;
      padding: 10px 15px;
      font-size: 14px;
      line-height: 21px;
      color: rgba(76, 80, 84, 1);
    }
  }
`;
